
import React, { createContext, useContext, useState, useEffect } from 'react';


// Common file for all the pages of the website where the Dark/Light Theme to be applied
const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [darkMode, setDarkMode] = useState(false);

  const toggleModes = () => {
    setDarkMode(prevMode => !prevMode);
    const newMode = !darkMode ? "dark" : "light";
    localStorage.setItem("displayMode", newMode);
  };

  // To save the the most recent theme selected by user
  useEffect(() => {
    const savedMode = localStorage.getItem("displayMode");
    if (savedMode) {
      setDarkMode(savedMode === "dark");
    }
  }, []);

  return (
    <ThemeContext.Provider value={{ darkMode, toggleModes }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
